import './styles/string-filter.scss'

import React, { useEffect, useState } from 'react'
import PropTypes  from 'prop-types'


const initialState = {
  value: '',
}

const StringFilter = ({ defaultValue, onChange, placeholder }) => {
  const [value, setValue] = useState(defaultValue || initialState.value)

  const clearValue = () => {
    setValue(initialState.value)
  }

  useEffect(() => {
    onChange(value)
  }, [value])

  return (
    <div className="string-filter">
      <div className="ui fluid icon input">
        <input type="text" placeholder={placeholder} value={value} onChange={(e) => setValue(e.currentTarget.value)} />

        <i className={value ? 'x icon' : ''} onClick={() => clearValue()} />
      </div>
    </div>
  )
}

StringFilter.propTypes = {
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
}

export default StringFilter
